import React, { useState, useCallback } from "react";
import "@/App.css";
import "@/index.css";
import { Toaster } from "sonner";
import { Routes, Route } from "react-router-dom";
import { ModalContext } from "@/lib/modal-context";

import MarqueeBar from "@/components/site/MarqueeBar";
import Navbar from "@/components/site/Navbar";
import SiteFooter from "@/components/site/SiteFooter";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import ConnectModal from "@/components/site/ConnectModal";
import EstimatorModal from "@/components/site/EstimatorModal";

import MainHome from "@/pages/MainHome";
import HomeInteriorsDubai from "@/pages/HomeInteriorsDubai";
import OfficeFitOutDubai from "@/pages/OfficeFitOutDubai";
import RetailBrandingDubai from "@/pages/RetailBrandingDubai";
import RestaurantInteriorsDubai from "@/pages/RestaurantInteriorsDubai";
import ContactUs from "@/pages/ContactUs";

/**
 * AppShell — the actual UI tree WITHOUT a router. This is wrapped by either
 * BrowserRouter (client, App.js) or StaticRouter (build-time SSR, scripts/ssr.mjs).
 * Keeping the router external allows us to prerender each route in Node.
 */
export default function AppShell() {
    const [connectOpen, setConnectOpen] = useState(false);
    const [connectPrefill, setConnectPrefill] = useState({});
    const [estimatorOpen, setEstimatorOpen] = useState(false);
    const [estimatorType, setEstimatorType] = useState("full_home");

    const openConnect = useCallback((prefill = {}) => {
        setConnectPrefill(prefill || {});
        setConnectOpen(true);
    }, []);
    const openEstimator = useCallback((type = "full_home") => {
        setEstimatorType(type);
        setEstimatorOpen(true);
    }, []);

    return (
        <ModalContext.Provider value={{ openConnect, openEstimator }}>
            <div className="min-h-screen bg-white" data-testid="site-root">
                <MarqueeBar />
                <Navbar />
                <Routes>
                    <Route path="/" element={<MainHome />} />
                    <Route path="/office-fit-out-dubai" element={<OfficeFitOutDubai />} />
                    <Route path="/home-interiors-dubai" element={<HomeInteriorsDubai />} />
                    <Route path="/retail-branding-dubai" element={<RetailBrandingDubai />} />
                    <Route path="/restaurant-interiors-dubai" element={<RestaurantInteriorsDubai />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="*" element={<MainHome />} />
                </Routes>
                <SiteFooter />
                <FloatingWhatsApp />
            </div>

            <ConnectModal
                open={connectOpen}
                onOpenChange={setConnectOpen}
                prefill={connectPrefill}
            />
            <EstimatorModal
                open={estimatorOpen}
                onOpenChange={setEstimatorOpen}
                initialType={estimatorType}
                onRequestConnect={(prefill) => {
                    setEstimatorOpen(false);
                    setTimeout(() => openConnect(prefill), 200);
                }}
            />

            <Toaster position="top-center" richColors />
        </ModalContext.Provider>
    );
}
